import React from "react";

export default function Confidentialite() {
  return (
    <div className="max-w-4xl mx-auto space-y-6">
      <header className="space-y-2">
        <h2 className="text-3xl font-semibold text-site">
          Confidentialité (vitrine)
        </h2>
        <p className="text-site-soft text-sm md:text-base">
          Ce texte n&apos;est pas un document juridique définitif, mais une
          esquisse de la manière dont MixMind pourrait aborder la question de la
          vie privée.
        </p>
      </header>

      <section className="card shadow-sm p-6 space-y-3 text-sm text-site-soft">
        <p>
          Dans une version aboutie, MixMind respecterait les réglementations en
          vigueur (par exemple le RGPD en Europe) et s&apos;engagerait à :
        </p>
        <ul className="list-disc ml-4 space-y-1">
          <li>ne pas vendre les données personnelles des utilisateurs ;</li>
          <li>limiter les données collectées au strict nécessaire ;</li>
          <li>
            proposer une lecture claire et compréhensible des réglages de
            confidentialité ;
          </li>
          <li>
            permettre la suppression et l&apos;export des données sur demande.
          </li>
        </ul>
        <p>
          Le but de cette vitrine est de montrer que la question de la
          confidentialité fait partie intégrante du concept, et pas un simple
          ajout technique.
        </p>
      </section>
    </div>
  );
}
